import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { Utils } from '../../../utils/utils';

@Component({
    selector: 'logshistorypopup',
    standalone: false,
    templateUrl: './logshistorypopup.component.html',
    styleUrls: ['../../../style/custom-mat-dialog.component.less', './logshistorypopup.component.less']
})
export class LogsHistoryPopupComponent implements OnInit {

    columnsToDisplay: string[] = [];  // Set below based on section
    public dataSource = new MatTableDataSource<RemoteActionHistoryPopupDto>();
    public title: string = 'Logs History';

    private readonly endpointMap: { [key: string]: string } = {
        'allowedactions': 'tenantconfigurationhistory',
        'allowedactionscontrollertype': 'controllertypeconfigurationhistory',
        'autoremoteresetcommand': 'autoremoteresetconfigurationhistory',
        'functionsconfig': 'functionsconfigurationhistory',
        'parametersconfig': 'parametersconfigurationhistory',
        'provisioningtemplate': 'provisioningconfigurationhistory',
        'remoteresetcommand': 'remoteresetconfigurationhistory'
    };

    private readonly titleMap: { [key: string]: string } = {
        'allowedactions': 'Tenant Configuration Logs',
        'allowedactionscontrollertype': 'Controller Type Configuration Logs',
        'autoremoteresetcommand': 'Auto Remote Reset Configuration Logs',
        'functionsconfig': 'Functions Configuration Logs',
        'parametersconfig': 'Parameters Configuration Logs',
        'provisioningtemplate': 'Provisioning Configuration Logs',
        'remoteresetcommand': 'Remote Reset Configuration Logs'
    };

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { section: string; tenantId?: string; controllerTypeId?: number },
        public dialogRef: MatDialogRef<LogsHistoryPopupComponent>,
        private readonly http: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string
    ) { }

    ngOnInit(): void {
        const section = this.data?.section;
        const endpoint = this.endpointMap[section];
        this.title = this.titleMap[section] || 'Logs History';

        // Configure columns to display based on section
        const baseColumns = ['Identifier', 'FieldName', 'OldValue', 'NewValue', 'Scope'];
        const showTenantId = section === 'allowedactions' || section === 'provisioningtemplate';
        const showControllerTypeId = ['allowedactionscontrollertype', 'autoremoteresetcommand', 'functionsconfig', 'parametersconfig', 'remoteresetcommand'].includes(section);
        
        this.columnsToDisplay = [
            ...baseColumns,
            ...(showTenantId ? ['TenantId'] : []),
            ...(showControllerTypeId ? ['ControllerTypeId'] : []),
            'ChangedBy',
            'CreatedAtUtc'
        ];

        const url = this.baseUrl + Utils.getRemoteActionAPI() + endpoint;
        this.http.get<RemoteActionHistoryPopupDto[]>(url).subscribe(result => {
            let filteredData = result;
            // Filter by tenant
            if (this.data?.tenantId) {
                filteredData = filteredData.filter(item => 
                    item.TenantId === this.data.tenantId || 
                    item.TenantId === null || 
                    item.TenantId === undefined
                );
            }
            // Filter by ControllerTypeId
            if (this.data?.controllerTypeId && this.data.controllerTypeId !== -1) {
                filteredData = filteredData.filter(item => 
                    item.ControllerTypeId === this.data.controllerTypeId || 
                    item.ControllerTypeId === null || 
                    item.ControllerTypeId === undefined
                );
            }
            this.dataSource.data = filteredData;
        });
    }

    applyFilter($event: any) {
        this.dataSource.filter = $event.target.value.trim().toLowerCase();
    }
}
